import CourseList from './CourseList';
import CourseCreate from './CourseCreate';
import CourseEdit from './CourseEdit';
import CourseSearch from './Search/CourseSearch';

export default {
    // list: CourseList,
    create: CourseCreate,
    edit: CourseEdit,
    list: CourseSearch   
};
